import { FloatingChat } from '@fiverr-private/go_floating_chat';

export default FloatingChat;
